import script from "./FormationSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./FormationSelection.vue?vue&type=script&setup=true&lang=js"

import "./FormationSelection.vue?vue&type=style&index=0&id=374d6a40&lang=css"

const __exports__ = script;

export default __exports__